import { axios } from '@/utils/request'

const api = {
  sellerGroupList: '/badminapi/seller/sellerGroupList',
  sellerGroupAdd: '/badminapi/seller/sellerGroupAdd',
  sellerGroupEdit: '/badminapi/seller/sellerGroupEdit',
  sellerGroupDelete: '/badminapi/seller/sellerGroupDelete',
  sellerGroupDetail: '/badminapi/seller/sellerGroupDetail',

}

export default api

export function getSellerGroupList(parameter) {
  return axios({
    url: api.sellerGroupList,
    method: 'get',
    params: parameter
  })
}
export function getSellerGroupDetail(parameter) {
  return axios({
    url: api.sellerGroupDetail,
    method: 'get',
    params: parameter
  })
}
export function editSellerGroup(parameter) {
  return axios({
    url: api.sellerGroupEdit,
    method: 'post',
    data: parameter
  })
}


export function addSellerGroup(parameter) {
  return axios({
    url: api.sellerGroupAdd,
    method: 'post',
    data: parameter
  })
}
export function deleteSellerGroup(parameter) {
  return axios({
    url: api.sellerGroupDelete,
    method: 'post',
    data: parameter
  })
}


